import { Device } from '@capacitor/device';
import { Capacitor } from '@capacitor/core';

export default class FingerprintGenerator {

    public static async generate(): Promise<string> {
        let fingerprint;
        if (Capacitor.getPlatform() === 'ios' || Capacitor.getPlatform() === 'android') {
            const deviceId = await Device.getId();
            fingerprint = deviceId.identifier;
        } else {
            fingerprint = this.generateWebFingerprint();
        }
        return fingerprint;
    }

    private static generateWebFingerprint(): string {
        const storedFingerprint = localStorage.getItem('web_fingerprint');
            
        if (storedFingerprint) {
            return storedFingerprint;
        } else {
            let fingerprint = '';

            fingerprint += 'UserAgent:' + navigator.userAgent + ';';
            fingerprint += 'ScreenSize:' + screen.width + 'x' + screen.height + ';';
            fingerprint += 'Language:' + navigator.language + ';';
            fingerprint += 'CookiesEnabled:' + navigator.cookieEnabled + ';';
            fingerprint += 'Timezone:' + new Date().getTimezoneOffset() + ';';
            fingerprint += 'Platform:' + navigator.platform + ';';
            fingerprint += 'CanvasFingerprint:' + this.generateCanvasFingerprint() + ';';

            const generatedFingerprint = this.generateHash(fingerprint) + '-' + this.generateUUID();
            
            localStorage.setItem('web_fingerprint', generatedFingerprint);

            return generatedFingerprint;
        }
    }

    private static generateUUID(): string {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            const r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    private static generateCanvasFingerprint(): string {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
    
        if (!ctx) {
            return 'CanvasFingerprint:NotAvailable';
        }

        ctx.textBaseline = 'alphabetic';
        ctx.fillStyle = '#f60';
        ctx.fillRect(125, 1, 62, 20);
        ctx.fillStyle = '#069';
        ctx.font = '11pt Arial';
        ctx.fillText('Cwm fjordbank glyphs vext quiz, 🧑‍🎨!', 2, 15);
    
        ctx.globalCompositeOperation = 'multiply';
        ctx.fillStyle = 'rgb(255,0,255)';
        ctx.beginPath();
        ctx.arc(50, 50, 50, 0, Math.PI * 2, true);
        ctx.closePath();
        ctx.fill();
        ctx.fillStyle = 'rgb(0,255,255)';
        ctx.beginPath();
        ctx.arc(100, 50, 50, 0, Math.PI * 2, true);
        ctx.closePath();
        ctx.fill();
        ctx.fillStyle = 'rgb(255,255,0)';
        ctx.beginPath();
        ctx.arc(75, 100, 50, 0, Math.PI * 2, true);
        ctx.closePath();
        ctx.fill();
        ctx.fillStyle = 'rgb(255,0,255)';
    
        // Devolver la representación del canvas como una cadena base64
        return canvas.toDataURL();
    }

    private static generateHash(data: string): string {
        let hash = 0;
        if (data.length === 0) return '';
    
        for (let i = 0; i < data.length; i++) {
            const chr = data.charCodeAt(i);
            hash = ((hash << 5) - hash) + chr;
            hash |= 0; // Convertir a un entero de 32 bits
        }
    
        // Convertir el hash a un string hexadecimal
        let result = '';
        const hexChars = '0123456789abcdef';
        do {
            result = hexChars.charAt(hash & 0xf) + result;
            hash >>>= 4;
        } while (hash > 0);
    
        return result;
    }
}